export default __webpack_public_path__ + "static/no-results-5cd1e82abc3f0b2444a370dc97568a1f.png";